import React, { memo } from "react";
import { Modal, Button } from "react-bootstrap";
import { Decrypt_Value, Encrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import axiosInstance from "../../axios/axios";
import { useHistory, useLocation } from "react-router-dom";

const Warning = (props) => {
  var uid = Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const history = useHistory();
  const location = useLocation();

  // const handleCancel = () => {
  //   props.onHide();
  //   if (props.navigateTo) {
  //     history.push(props.navigateTo);
  //   } else if (props.popupTitle !== "Task Management") {
  //     history.goBack();
  //   }
  // };
  const handleCancel = () => {
    props.onHide();

    if (location.pathname.includes("/settings/deleteaccount")) {
      return;
    }

    if (props.navigateTo) {
      history.push(props.navigateTo);
    } else if (props.popupTitle !== "Task Management") {
      history.goBack();
    }
  };
  const generateRandomPassword = (length = 10) => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    return Array.from(
      { length },
      () => charset[Math.floor(Math.random() * charset.length)],
    ).join("");
  };
  const launchWebsite = () => {
    axiosInstance
      .get("/vozo/loginemail?uid=" + uid)
      .then((res) => {
        let data = Decrypt_Value(res.data, "vozo");
        const randomPassword = generateRandomPassword();
        const EncryptrandomPassword = Encrypt_Value(randomPassword, "vozo");
        const url = new URL("https://signup.vozohealth.com/direct-login.php");
        url.searchParams.append("token", EncryptrandomPassword);
        url.searchParams.append("email", data["email"]);

        axiosInstance
          .put("/vozo/feedbackloginpass?uid=" + uid, EncryptrandomPassword)
          .then((res) => {
            let data = Decrypt_Value(res.data, "vozo");
          })
          .catch((err) => {
            console.error("there was an error while updating login status");
          });
        window.open(url.toString(), "_blank");
      })
      .catch((err) => {
        console.error("there was an error while updating login status");
      });
  };

  return (
    <Modal
      {...props}
      show={props.show}
      onHide={handleCancel}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="upgrade-req-modal popup_centre"
      style={props.bgchange ? { backgroundColor: "rgba(0,0,0,.25)" } : {}}
    >
      <Modal.Header closeButton>
        <Modal.Title>Upgrade Required</Modal.Title>
      </Modal.Header>

      <Modal.Body className="upg-req-margin">
        <div className="upg-req-one">
          <div className="req-1-line1">{props.popupTitle}</div>
          <div className="req-1-line2">{props.description}</div>
          <div className="req-1-line3">{props.boxContent}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="text-right w-100">
          <Button
            className="upg-req-modal"
            variant="light"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            className="upg-req-btn"
            variant="primary"
            onClick={launchWebsite}
          >
            Upgrade
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(Warning);
